export default "__VITE_ASSET__bc901e0d__"